/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2} from "@mui/material";
import {useAvisos} from "../../Modulo_Avisos/Hooks/useAvisos";
import {useLoaders} from "../../Modulo_Loaders/Hooks/useLoaders";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {guardarRegistro} from "../../Modulo_Algolia/Funciones/guardarRegistro";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {borrarRegistro} from "../../Modulo_Algolia/Funciones/borrarRegistro";
import Formulario_Producto_SubCategoria from "../Formularios/Formulario_Producto_SubCategoria";

const Dialogo_Productos_SubCat = ({datos, cerrar, realizado}) => {
    const {Avisos, nuevoAviso, terminar} = useAvisos({funcionUno: cerrar, funcionDos: realizado})
    const {Cargador, abrirCargador, setDetener} = useLoaders({logo: logo})
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})


    const subirDatos = async (datos) => {

        let entidad = await obtenerEntidad()

        abrirCargador('Guardando Datos')
        entidad.fecha = new Date().getTime()

        if (entidad.objectID) {
            entidad.id = entidad.objectID
        }



        delete entidad.objectID

        nuevoAviso({aviso: 'SubCategorias agregadas'})

        let dox = await guardarDoc('productos', entidad)
        if (dox.res) {
            await guardarRegistro({obj: entidad, coleccion: 'productos', id: dox.data})
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }

        cerrar()
        realizado()


    }

    const borrar = async () => {
        await borrarDoc('productos', datos.id)
        terminar({aviso: 'Usuarios borrado'})
        await borrarRegistro({coleccion: 'productos', id: datos.id})
    }
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Producto_SubCategoria props={props}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid2>

            {datos && datos.id &&
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid2>
            }


        </Grid2>
    )

}
export default Dialogo_Productos_SubCat